module.exports = __webpack_public_path__ + "4284f7e6c88e1350648ed3dc39bd7ee5.svg";